import { ChooseProductPage } from '@/features/quotes/components/choose-product-page.component';
import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/quotes/products/')({
  component: RouteComponent,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions(['policies.quotes.write']);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function RouteComponent() {
  return <ChooseProductPage />;
}
